export { default as VictoryPolarAxis } from "./victory-polar-axis";


//////////////////
// WEBPACK FOOTER
// ./~/victory-polar-axis/es/index.js
// module id = ./node_modules/victory-polar-axis/es/index.js
// module chunks = 1